<template>
  <div class="sobre-nos">
    <SobreNosComp />
</div>
</template>

<script>

import SobreNosComp from '@/components/SobreNosComp.vue'

export default {
  name: 'SobreNosView',
  components: {
    SobreNosComp
  }
}
</script>
